import { motion } from "framer-motion";
import React from "react";
import logo from "../assets/svg/logo.svg";
import background from "../assets/svg/background.svg";
import flame from "../assets/svg/flame.svg";
import play from "../assets/svg/play.svg";
import { useCopyToClipboard } from "react-use";
import {
  Copy,
  InstagramLogo,
  ShareNetwork,
  Spinner,
  TwitterLogo,
  X,
} from "phosphor-react";
import { CopyToClipboardState } from "react-use/lib/useCopyToClipboard";
import { gql, useMutation } from "@apollo/client";
import { useLocation } from "react-router-dom";

export const socialMediaHandles = [
  {
    name: "Twitter",
    icon: TwitterLogo,
    link: "https://twitter.com/beatfro",
  },
  {
    name: "Instagram",
    icon: InstagramLogo,
    link: "https://instagram.com/beatfro",
  },
];

interface Props {
  email: string;
  setEmail: React.Dispatch<React.SetStateAction<string>>;
  refLink: string;
  setRefLink: React.Dispatch<React.SetStateAction<string>>;
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleSubmit: () => void;
  copied: CopyToClipboardState;
  copy: (value: string) => void;
  submitted: boolean;
  setSubmitted: React.Dispatch<React.SetStateAction<boolean>>;
  loading: boolean;
}

const JOIN = gql`
  mutation Join($templateId: String!, $email: String!, $ref: String) {
    joinWaitlist(templateId: $templateId, email: $email, ref: $ref) {
      ref
      status
    }
  }
`;

const Index = () => {
  const [modalOpen, setModalOpen] = React.useState(false);
  const [submitted, setSubmitted] = React.useState(false);
  const [join, { loading }] = useMutation(JOIN, {
    onCompleted: (data) => {
      setSubmitted(true);
      setRefLink(window.location.hostname + "/?ref=" + data.joinWaitlist.ref);
    },
  });

  const { search } = useLocation();

  const query = React.useMemo(() => new URLSearchParams(search), [search]);

  const [copied, copy] = useCopyToClipboard();
  const [refLink, setRefLink] = React.useState("");
  const [email, setEmail] = React.useState("");

  console.log("ref: ", query.get("ref"));

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const handleSubmit = React.useCallback(() => {
    setModalOpen(true);
    join({
      variables: {
        email,
        templateId: "d-6533671d971c418b971a209a40b6ab73",
        ref: query.get("ref"),
      },
    });
  }, [email, join, query]);

  const props = {
    email,
    setEmail,
    refLink,
    setRefLink,
    modalOpen,
    setModalOpen,
    handleSubmit,
    copied,
    copy,
    submitted,
    setSubmitted,
    loading,
  };

  return (
    <>
      <Desktop {...props} />
      <Mobile {...props} />
    </>
  );
};

const Desktop: React.FC<Props> = ({
  setEmail,
  refLink,
  modalOpen,
  setModalOpen,
  handleSubmit,
  copied,
  copy,
  submitted,
  loading,
}) => {
  return (
    <div className='hidden lg:block bg-[#5C34B3] w-screen h-screen text-white font-poppins'>
      <img
        src={background}
        alt='background'
        className='w-screen h-screen fixed top-0 left-0 object-cover z-0'
      />
      {/* Logo */}
      <div className='fixed top-0 left-0 text-xs font-poppins my-10 mx-32 flex items-center space-x-1'>
        <img src={logo} alt='Beatfro' className='w-8' />
        <span className='text-lg font-bold'>Beatfro</span>
      </div>
      {/* Copyright */}
      <div className='fixed bottom-0 left-0 text-xs font-poppins my-4 mx-6'>
        &copy; 2022 Beatfro. All Rights Reserved.
      </div>
      {/* Left Icon */}
      <img
        src={flame}
        alt='flame'
        className='z-1 fixed top-[50%] -translate-y-[50%] left-36'
      />
      {/* Right Icon */}
      <img
        src={play}
        alt='flame'
        className='z-1 fixed top-[50%] -translate-y-[50%] right-36'
      />
      {/* Main Content */}
      <div className='flex flex-col justify-end h-screen fixed left-1/2 transform -translate-x-1/2 z-30 items-center text-center space-y-6 overflow-hidden'>
        <div className='text-7xl font-bold max-w-lg transition relative mb-8'>
          Listening
          <br /> is everything.
          <svg
            className='absolute right-0 top-0 -translate-x-6 -translate-y-6'
            width='67'
            height='63'
            viewBox='0 0 67 63'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M22.7507 57.1221C22.517 56.1133 23.208 55.0901 24.294 54.8368C33.2765 52.7416 42.3191 51.0475 51.3278 49.3597C52.4744 49.1449 53.6205 48.9302 54.7658 48.7148C55.8615 48.5087 56.8981 49.1681 57.081 50.1876C57.2639 51.2071 56.5239 52.2007 55.4282 52.4068C54.2799 52.6227 53.1329 52.8377 51.9871 53.0523C42.9674 54.7423 34.0233 56.4181 25.1403 58.4901C24.0543 58.7434 22.9844 58.1309 22.7507 57.1221Z'
              fill='white'
            />
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M59.7041 23.1241C60.2192 24.1273 59.8505 25.3582 58.8805 25.8735C57.05 26.8459 55.2201 27.8153 53.3917 28.784C42.7057 34.445 32.0696 40.0795 21.6571 46.1332C20.707 46.6855 19.4902 46.3363 18.9392 45.353C18.3882 44.3698 18.7117 43.1249 19.6618 42.5726C30.1461 36.4772 40.8583 30.8024 51.5415 25.143C53.3673 24.1758 55.1922 23.209 57.015 22.2407C57.9849 21.7254 59.1889 22.1209 59.7041 23.1241Z'
              fill='white'
            />
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M30.6257 6.69984C31.4778 7.35407 31.6432 8.57752 30.9952 9.43249L9.86164 37.3169C9.21365 38.1718 7.99766 38.3346 7.14563 37.6803C6.29361 37.0261 6.12821 35.8027 6.77619 34.9477L27.9097 7.06333C28.5577 6.20836 29.7737 6.04562 30.6257 6.69984Z'
              fill='white'
            />
          </svg>
          <svg
            className='absolute top-full z-[-1] -translate-y-4'
            width='100%'
            height='45'
            viewBox='0 0 539 45'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M192.123 4.80441C271.325 1.42722 350.611 -0.34353 429.9 0.0554776C445.832 0.135653 461.706 0.397532 477.569 0.659231C496.581 0.972887 515.578 1.28629 534.641 1.28629C536.033 1.28629 537.006 1.28268 537.59 1.27955C537.882 1.27799 538.077 1.27655 538.178 1.27573L538.202 1.27571L538.234 1.2755L538.247 1.2752L538.25 1.27518L538.252 1.27514L538.253 1.27513L538.254 1.27511L538.263 1.27502L538.27 1.27498L538.294 1.27508C539.829 2.68389 538.394 4.25891 538.317 4.26274L538.301 4.26308L538.297 4.26313L538.294 4.26317L538.286 4.26323L538.285 4.26324L538.283 4.26329L538.264 4.26343L538.24 4.26379C537.922 4.26748 536.168 4.28934 533.216 4.36201C496.786 5.25891 460.37 7.18075 423.961 9.30087C448.366 9.21121 472.75 9.19876 497.1 9.19876C514.471 9.19876 523.199 9.22331 524.858 9.26733C524.962 9.2701 525.06 9.27343 525.136 9.27804C525.161 9.27959 525.238 9.28413 525.322 9.29636C525.385 9.30667 525.606 9.36315 525.761 9.424C526.439 10.0157 526.38 11.6264 525.739 12.1398C525.594 12.1946 525.387 12.2467 525.327 12.2567C525.293 12.2614 525.24 12.2676 525.215 12.27C525.167 12.2744 525.119 12.2772 525.082 12.2791C525.003 12.2832 524.901 12.2868 524.785 12.2902C524.319 12.3037 523.44 12.3179 522.185 12.333C519.667 12.3632 515.588 12.3972 510.154 12.4343C488.414 12.5827 444.938 12.7805 392.77 12.9783C381.974 13.0192 370.805 13.0602 359.38 13.1007C259.944 18.7845 160.489 23.2266 60.9864 27.242C52.5846 28.0912 44.1889 28.9883 35.7998 29.9359C35.5461 29.9646 35.264 29.9983 34.9583 30.0364C41.4599 30.0739 47.9642 29.9914 54.4858 29.9087C59.6586 29.8431 64.8422 29.7773 70.044 29.7712C76.2585 29.7639 82.473 29.76 88.6873 29.7561C148.692 29.7183 208.687 29.6805 268.565 26.6083C282.969 25.8693 297.375 25.1807 311.78 24.5051C317.126 24.138 322.455 23.7877 327.759 23.4391C328.622 23.3823 329.485 23.3256 330.347 23.2689C331.8 23.1733 345.126 22.6377 353.795 22.3283C355.966 22.2508 357.853 22.1873 359.196 22.1481C359.866 22.1286 360.407 22.115 360.781 22.1089C360.965 22.1058 361.122 22.1044 361.238 22.1055C361.29 22.106 361.361 22.1072 361.43 22.1116L361.432 22.1117C361.456 22.1132 361.542 22.1187 361.644 22.1373C361.668 22.1417 361.847 22.1715 362.05 22.2681C362.178 22.3365 362.495 22.5852 362.658 22.7839C362.842 23.1515 362.873 23.9566 362.72 24.3349C362.575 24.542 362.284 24.8107 362.163 24.8883C362.088 24.9295 361.959 24.9883 361.905 25.0086C361.806 25.0445 361.724 25.0629 361.694 25.0696C361.665 25.0757 361.639 25.0808 361.615 25.0849C361.579 25.0912 361.55 25.0952 361.534 25.0974C361.502 25.1017 361.468 25.1056 361.435 25.109C361.403 25.1124 361.371 25.1155 361.341 25.1181C361.214 25.1295 361.037 25.1424 360.814 25.1571C360.364 25.1867 359.683 25.226 358.744 25.2763C356.863 25.377 353.923 25.5229 349.667 25.7244C342.02 26.0863 334.375 26.4426 326.73 26.7988C321.814 27.0278 316.899 27.2569 311.984 27.4874C276.23 29.9435 239.937 33.136 205.419 41.5621C212.472 41.0393 219.517 40.1703 226.587 39.2982C231.168 38.733 235.76 38.1666 240.372 37.6922C241.227 37.6043 241.994 38.1981 242.085 39.0186C242.177 39.8391 241.558 40.5756 240.704 40.6635C236.233 41.1234 231.717 41.6802 227.173 42.2403C217.301 43.4573 207.301 44.6902 197.367 44.9792C195.915 45.0214 194.861 45.004 194.229 44.8838C194.066 44.8527 193.82 44.7956 193.574 44.6732C193.377 44.5752 192.78 44.2325 192.664 43.4748C192.549 42.7284 193.006 42.2393 193.151 42.0987C193.339 41.9175 193.542 41.7976 193.67 41.7286C194.158 41.4642 194.938 41.2154 195.667 41.0013C196.45 40.7717 197.376 40.5264 198.27 40.2894L198.279 40.287C214.7 35.9377 231.548 32.8428 248.555 30.517C195.294 32.6774 141.962 32.7109 88.6968 32.7444C82.4795 32.7483 76.2631 32.7522 70.0478 32.7595C64.9269 32.7655 59.7855 32.8306 54.6331 32.8958C43.7752 33.0333 32.869 33.1714 22.0049 32.7583C21.691 32.7464 21.3952 32.7246 21.1433 32.683C21.02 32.6626 20.8576 32.6297 20.6892 32.5704C20.5718 32.529 20.1996 32.3929 19.9085 32.0354C19.7374 31.8252 19.5893 31.53 19.5685 31.1682C19.5482 30.8147 19.6566 30.5246 19.7723 30.3258C19.9736 29.9796 20.2616 29.7941 20.3612 29.732C20.6072 29.5785 20.8882 29.4769 21.0805 29.4129C21.728 29.1973 22.8102 28.9558 24.0594 28.714C16.5797 29.0088 9.09962 29.3018 1.61926 29.5933C0.760538 29.6267 0.0361528 28.9855 0.00130404 28.1609C-0.0335448 27.3364 0.634339 26.6409 1.49306 26.6074C21.2507 25.8376 41.0057 25.0573 60.7583 24.2602C111.267 19.1572 161.99 15.7816 212.798 13.5492C160.323 13.6825 112.384 13.7696 79.7517 13.7696C77.4008 13.7696 75.624 13.7524 74.3737 13.7194C73.7499 13.7029 73.2437 13.6822 72.8567 13.6564C72.5293 13.6346 72.1326 13.6018 71.8364 13.5197C71.764 13.4997 71.5662 13.443 71.3575 13.3125C71.2208 13.2271 70.48 12.7189 70.6583 11.7702C70.7321 11.3775 70.9449 11.1167 71.0798 10.983C71.2173 10.8467 71.3529 10.763 71.4323 10.7185C71.5898 10.6304 71.7351 10.5824 71.8068 10.5601C72.0797 10.4755 72.4468 10.4213 72.769 10.3798C73.4913 10.2869 74.6259 10.1855 76.0906 10.0765C81.9698 9.63891 93.7064 9.04054 107.758 8.39345C127.471 7.48567 151.798 6.47949 171.038 5.68368C179.242 5.34437 186.521 5.0433 192.123 4.80441ZM126.975 21.5162C180.338 17.6072 233.885 15.3341 287.472 14.0131C233.984 16.7743 180.487 19.233 126.975 21.5162ZM366.757 9.68301C353.23 9.82129 339.701 9.99875 326.171 10.2264C254.999 10.463 178.494 10.6686 121.961 10.7472C138.414 10.0241 156.3 9.28434 171.16 8.66971C179.367 8.33025 186.652 8.02897 192.261 7.78977C271.42 4.41443 350.653 2.64502 429.884 3.04374C444.605 3.11782 459.375 3.34939 474.157 3.59199C448.591 4.82872 423.039 6.35021 397.51 7.8703C388.003 8.43637 378.499 9.00224 369 9.55314C368.252 9.5965 367.504 9.63979 366.757 9.68301ZM195.199 44.3315C195.199 44.3311 195.2 44.3307 195.201 44.3303C195.191 44.3363 195.189 44.3366 195.199 44.3315ZM21.6615 29.7362C21.6615 29.7362 21.6632 29.7365 21.6664 29.7372C21.663 29.7366 21.6614 29.7363 21.6615 29.7362Z'
              fill='#FFB800'
            />
          </svg>
        </div>
        <div className='max-w-sm font-medium transition'>
          Join the waitlist and stream millions of songs from your favourite
          african artists on our platform
        </div>
        <div className='transition flex items-center space-x-3'>
          <motion.input
            type='email'
            placeholder='Email Address'
            name='email'
            id='email'
            className='input bg-white text-black'
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
          />
          <button
            disabled={loading}
            className='btn'
            onClick={() => handleSubmit()}
          >
            Get Early Access
          </button>
        </div>
        <motion.img
          initial={{
            translateY: "100%",
          }}
          animate={{
            translateY: "0%",
          }}
          transition={{
            duration: 0.8,
            ease: "easeInOut",
          }}
          src={require("../assets/images/Lyrics.png")}
          alt='Now Playing'
          className='w-[35vw] h-[30vh] object-cover object-top'
        />
      </div>
      {/* Modal */}
      {loading ? (
        <div className='flex items-center justify-center fixed h-screen inset-0 w-screen z-50 transition-all ease-in-out duration-300'>
          <div className='absolute inset-0 h-screen w-screen glass-backdrop'></div>
          <Spinner size='32' color='white' className='animate-spin' />
        </div>
      ) : (
        <div
          className={`${
            modalOpen ? "flex" : "hidden"
          } fixed h-screen inset-0 w-screen z-50 transition-all ease-in-out duration-300`}
        >
          <div className='absolute inset-0 h-screen w-screen glass-backdrop'></div>
          <div className='absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#5C34B3]/95 rounded-md shadow-lg p-10 lg:max-w-md'>
            {/* X Icon */}
            <div
              onClick={() => setModalOpen(false)}
              className='bg-main-300/20 absolute z-20 right-0 top-0 m-5 cursor-pointer rounded-full p-2'
            >
              <X size={22} color='white' />
            </div>
            {!submitted ? (
              // Register
              <div className='w-full flex items-center justify-center py-12'>
                <div className='flex flex-col space-y-4'>
                  <h3 className='font-bold text-4xl'>Ooops!</h3>
                  <p className='text-xl font-bold'>
                    something went wrong. try again later
                  </p>
                  <div>
                    <p className='text-sm font-semibold'>You could try</p>
                    <ul className='list-disc ml-6 text-sm'>
                      <li>Refreshing this page</li>
                      <li>Checking your internet connection</li>
                    </ul>
                  </div>
                </div>
              </div>
            ) : (
              <motion.div
                initial={{
                  opacity: 0,
                  scale: 0.4,
                  translateY: "20%",
                }}
                animate={{
                  opacity: 1,
                  scale: 1,
                  translateY: 0,
                }}
                transition={{
                  duration: 0.2,
                  ease: "easeInOut",
                }}
                className='w-full flex flex-col items-center space-y-6 py-6'
              >
                <motion.div className='flex flex-col items-center space-y-10'>
                  <h2 className='text-5xl font-bold text-center relative'>
                    Congrats pal
                    <svg
                      className='absolute top-full z-[-1] -translate-y-4'
                      width='100%'
                      height='45'
                      viewBox='0 0 539 45'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        fillRule='evenodd'
                        clipRule='evenodd'
                        d='M192.123 4.80441C271.325 1.42722 350.611 -0.34353 429.9 0.0554776C445.832 0.135653 461.706 0.397532 477.569 0.659231C496.581 0.972887 515.578 1.28629 534.641 1.28629C536.033 1.28629 537.006 1.28268 537.59 1.27955C537.882 1.27799 538.077 1.27655 538.178 1.27573L538.202 1.27571L538.234 1.2755L538.247 1.2752L538.25 1.27518L538.252 1.27514L538.253 1.27513L538.254 1.27511L538.263 1.27502L538.27 1.27498L538.294 1.27508C539.829 2.68389 538.394 4.25891 538.317 4.26274L538.301 4.26308L538.297 4.26313L538.294 4.26317L538.286 4.26323L538.285 4.26324L538.283 4.26329L538.264 4.26343L538.24 4.26379C537.922 4.26748 536.168 4.28934 533.216 4.36201C496.786 5.25891 460.37 7.18075 423.961 9.30087C448.366 9.21121 472.75 9.19876 497.1 9.19876C514.471 9.19876 523.199 9.22331 524.858 9.26733C524.962 9.2701 525.06 9.27343 525.136 9.27804C525.161 9.27959 525.238 9.28413 525.322 9.29636C525.385 9.30667 525.606 9.36315 525.761 9.424C526.439 10.0157 526.38 11.6264 525.739 12.1398C525.594 12.1946 525.387 12.2467 525.327 12.2567C525.293 12.2614 525.24 12.2676 525.215 12.27C525.167 12.2744 525.119 12.2772 525.082 12.2791C525.003 12.2832 524.901 12.2868 524.785 12.2902C524.319 12.3037 523.44 12.3179 522.185 12.333C519.667 12.3632 515.588 12.3972 510.154 12.4343C488.414 12.5827 444.938 12.7805 392.77 12.9783C381.974 13.0192 370.805 13.0602 359.38 13.1007C259.944 18.7845 160.489 23.2266 60.9864 27.242C52.5846 28.0912 44.1889 28.9883 35.7998 29.9359C35.5461 29.9646 35.264 29.9983 34.9583 30.0364C41.4599 30.0739 47.9642 29.9914 54.4858 29.9087C59.6586 29.8431 64.8422 29.7773 70.044 29.7712C76.2585 29.7639 82.473 29.76 88.6873 29.7561C148.692 29.7183 208.687 29.6805 268.565 26.6083C282.969 25.8693 297.375 25.1807 311.78 24.5051C317.126 24.138 322.455 23.7877 327.759 23.4391C328.622 23.3823 329.485 23.3256 330.347 23.2689C331.8 23.1733 345.126 22.6377 353.795 22.3283C355.966 22.2508 357.853 22.1873 359.196 22.1481C359.866 22.1286 360.407 22.115 360.781 22.1089C360.965 22.1058 361.122 22.1044 361.238 22.1055C361.29 22.106 361.361 22.1072 361.43 22.1116L361.432 22.1117C361.456 22.1132 361.542 22.1187 361.644 22.1373C361.668 22.1417 361.847 22.1715 362.05 22.2681C362.178 22.3365 362.495 22.5852 362.658 22.7839C362.842 23.1515 362.873 23.9566 362.72 24.3349C362.575 24.542 362.284 24.8107 362.163 24.8883C362.088 24.9295 361.959 24.9883 361.905 25.0086C361.806 25.0445 361.724 25.0629 361.694 25.0696C361.665 25.0757 361.639 25.0808 361.615 25.0849C361.579 25.0912 361.55 25.0952 361.534 25.0974C361.502 25.1017 361.468 25.1056 361.435 25.109C361.403 25.1124 361.371 25.1155 361.341 25.1181C361.214 25.1295 361.037 25.1424 360.814 25.1571C360.364 25.1867 359.683 25.226 358.744 25.2763C356.863 25.377 353.923 25.5229 349.667 25.7244C342.02 26.0863 334.375 26.4426 326.73 26.7988C321.814 27.0278 316.899 27.2569 311.984 27.4874C276.23 29.9435 239.937 33.136 205.419 41.5621C212.472 41.0393 219.517 40.1703 226.587 39.2982C231.168 38.733 235.76 38.1666 240.372 37.6922C241.227 37.6043 241.994 38.1981 242.085 39.0186C242.177 39.8391 241.558 40.5756 240.704 40.6635C236.233 41.1234 231.717 41.6802 227.173 42.2403C217.301 43.4573 207.301 44.6902 197.367 44.9792C195.915 45.0214 194.861 45.004 194.229 44.8838C194.066 44.8527 193.82 44.7956 193.574 44.6732C193.377 44.5752 192.78 44.2325 192.664 43.4748C192.549 42.7284 193.006 42.2393 193.151 42.0987C193.339 41.9175 193.542 41.7976 193.67 41.7286C194.158 41.4642 194.938 41.2154 195.667 41.0013C196.45 40.7717 197.376 40.5264 198.27 40.2894L198.279 40.287C214.7 35.9377 231.548 32.8428 248.555 30.517C195.294 32.6774 141.962 32.7109 88.6968 32.7444C82.4795 32.7483 76.2631 32.7522 70.0478 32.7595C64.9269 32.7655 59.7855 32.8306 54.6331 32.8958C43.7752 33.0333 32.869 33.1714 22.0049 32.7583C21.691 32.7464 21.3952 32.7246 21.1433 32.683C21.02 32.6626 20.8576 32.6297 20.6892 32.5704C20.5718 32.529 20.1996 32.3929 19.9085 32.0354C19.7374 31.8252 19.5893 31.53 19.5685 31.1682C19.5482 30.8147 19.6566 30.5246 19.7723 30.3258C19.9736 29.9796 20.2616 29.7941 20.3612 29.732C20.6072 29.5785 20.8882 29.4769 21.0805 29.4129C21.728 29.1973 22.8102 28.9558 24.0594 28.714C16.5797 29.0088 9.09962 29.3018 1.61926 29.5933C0.760538 29.6267 0.0361528 28.9855 0.00130404 28.1609C-0.0335448 27.3364 0.634339 26.6409 1.49306 26.6074C21.2507 25.8376 41.0057 25.0573 60.7583 24.2602C111.267 19.1572 161.99 15.7816 212.798 13.5492C160.323 13.6825 112.384 13.7696 79.7517 13.7696C77.4008 13.7696 75.624 13.7524 74.3737 13.7194C73.7499 13.7029 73.2437 13.6822 72.8567 13.6564C72.5293 13.6346 72.1326 13.6018 71.8364 13.5197C71.764 13.4997 71.5662 13.443 71.3575 13.3125C71.2208 13.2271 70.48 12.7189 70.6583 11.7702C70.7321 11.3775 70.9449 11.1167 71.0798 10.983C71.2173 10.8467 71.3529 10.763 71.4323 10.7185C71.5898 10.6304 71.7351 10.5824 71.8068 10.5601C72.0797 10.4755 72.4468 10.4213 72.769 10.3798C73.4913 10.2869 74.6259 10.1855 76.0906 10.0765C81.9698 9.63891 93.7064 9.04054 107.758 8.39345C127.471 7.48567 151.798 6.47949 171.038 5.68368C179.242 5.34437 186.521 5.0433 192.123 4.80441ZM126.975 21.5162C180.338 17.6072 233.885 15.3341 287.472 14.0131C233.984 16.7743 180.487 19.233 126.975 21.5162ZM366.757 9.68301C353.23 9.82129 339.701 9.99875 326.171 10.2264C254.999 10.463 178.494 10.6686 121.961 10.7472C138.414 10.0241 156.3 9.28434 171.16 8.66971C179.367 8.33025 186.652 8.02897 192.261 7.78977C271.42 4.41443 350.653 2.64502 429.884 3.04374C444.605 3.11782 459.375 3.34939 474.157 3.59199C448.591 4.82872 423.039 6.35021 397.51 7.8703C388.003 8.43637 378.499 9.00224 369 9.55314C368.252 9.5965 367.504 9.63979 366.757 9.68301ZM195.199 44.3315C195.199 44.3311 195.2 44.3307 195.201 44.3303C195.191 44.3363 195.189 44.3366 195.199 44.3315ZM21.6615 29.7362C21.6615 29.7362 21.6632 29.7365 21.6664 29.7372C21.663 29.7366 21.6614 29.7363 21.6615 29.7362Z'
                        fill='#FFB800'
                      />
                    </svg>
                  </h2>
                  <p className='text-center text-sm font-medium'>
                    Hurray, you have successfully joined our waitlist. we will
                    send you an email informing you when we are launching.
                    Before you go, please help us refer a friend.
                  </p>
                  <div className='bg-white w-full overflow-x-hidden rounded-md p-2  text-main-200'>
                    <p className='text-xs'>Here's your referal link</p>
                    <span className='w-full text-sm font-medium overflow-x-hidden truncate'>
                      {refLink.slice(0, 50)}...
                    </span>
                  </div>
                  <button
                    className='btn w-full flex items-center space-x-2 justify-center'
                    onClick={() => copy(refLink)}
                  >
                    <Copy color='white' size={20} />
                    <span>
                      {copied.value === refLink ? "Copied" : "Copy Link"}
                    </span>
                  </button>
                </motion.div>
              </motion.div>
            )}
            <div className='flex items-center space-x-2 justify-center mt-14'>
              {socialMediaHandles.map((handle, index) => {
                return (
                  <a
                    key={index}
                    href={handle.link}
                    title={handle.name}
                    target='_blank'
                    rel='noreferrer'
                    className='bg-main-200/30 hover:bg-main-200/40 cursor-pointer rounded-md p-2'
                  >
                    {<handle.icon color='white' size={20} />}
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      )}
      <div className='fixed bottom-0 right-0 text-xs font-poppins my-4 mx-6 flex items-center space-x-2'>
        {socialMediaHandles.map((handle, index) => {
          return (
            <a
              key={index}
              href={handle.link}
              title={handle.name}
              target='_blank'
              rel='noreferrer'
              className='bg-main-200/30 hover:bg-main-200/40 cursor-pointer rounded-md p-2'
            >
              {<handle.icon color='white' size={20} />}
            </a>
          );
        })}
      </div>
    </div>
  );
};

const shareData = {
  text: "Join the waitlist and stream millions of songs from your favourite african artists on our platform",
  title: "Beatfro: Listening is Everything",
  url: "https://beatfrowaitlist.netlify.app",
};

const Mobile: React.FC<Props> = ({
  setEmail,
  refLink,
  handleSubmit,
  copied,
  copy,
  submitted,
  loading,
}) => {
  const share = React.useCallback(() => {
    navigator.share(shareData);
  }, []);

  return (
    <div className='lg:hidden bg-white w-screen min-h-screen text-black font-poppins'>
      {/* NavBar */}
      <div className='flex items-center p-6 justify-between'>
        <div className='text-xs font-poppins flex items-center space-x-1'>
          <img src={logo} alt='Beatfro' className='w-8' />
          <span className='text-lg font-semibold'>Beatfro</span>
        </div>
        <ShareNetwork size={24} onClick={share} />
      </div>
      <motion.div className='bg-[#5C34B3] overflow-hidden relative rounded-xl z-10 px-4 py-16 pb-0 space-y-10 flex flex-col items-center text-center my-6 mx-3 text-white'>
        <img
          src={background}
          alt='background'
          className='w-full h-full absolute top-0 left-0 object-cover z-[-1]'
        />
        <div className='text-4xl md:text-6xl font-bold max-w-lg transition relative mb-8 z-10'>
          {submitted ? (
            "Congrats pal"
          ) : (
            <>
              Listening
              <br /> is everything.
            </>
          )}

          {!submitted && (
            <svg
              className='absolute w-10 right-0 top-0 -translate-x-2 -translate-y-8'
              width='67'
              height='63'
              viewBox='0 0 67 63'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M22.7507 57.1221C22.517 56.1133 23.208 55.0901 24.294 54.8368C33.2765 52.7416 42.3191 51.0475 51.3278 49.3597C52.4744 49.1449 53.6205 48.9302 54.7658 48.7148C55.8615 48.5087 56.8981 49.1681 57.081 50.1876C57.2639 51.2071 56.5239 52.2007 55.4282 52.4068C54.2799 52.6227 53.1329 52.8377 51.9871 53.0523C42.9674 54.7423 34.0233 56.4181 25.1403 58.4901C24.0543 58.7434 22.9844 58.1309 22.7507 57.1221Z'
                fill='white'
              />
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M59.7041 23.1241C60.2192 24.1273 59.8505 25.3582 58.8805 25.8735C57.05 26.8459 55.2201 27.8153 53.3917 28.784C42.7057 34.445 32.0696 40.0795 21.6571 46.1332C20.707 46.6855 19.4902 46.3363 18.9392 45.353C18.3882 44.3698 18.7117 43.1249 19.6618 42.5726C30.1461 36.4772 40.8583 30.8024 51.5415 25.143C53.3673 24.1758 55.1922 23.209 57.015 22.2407C57.9849 21.7254 59.1889 22.1209 59.7041 23.1241Z'
                fill='white'
              />
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M30.6257 6.69984C31.4778 7.35407 31.6432 8.57752 30.9952 9.43249L9.86164 37.3169C9.21365 38.1718 7.99766 38.3346 7.14563 37.6803C6.29361 37.0261 6.12821 35.8027 6.77619 34.9477L27.9097 7.06333C28.5577 6.20836 29.7737 6.04562 30.6257 6.69984Z'
                fill='white'
              />
            </svg>
          )}
          <svg
            className='absolute -translate-y-5 z-[-1]'
            width='100%'
            height='45'
            viewBox='0 0 539 45'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              d='M192.123 4.80441C271.325 1.42722 350.611 -0.34353 429.9 0.0554776C445.832 0.135653 461.706 0.397532 477.569 0.659231C496.581 0.972887 515.578 1.28629 534.641 1.28629C536.033 1.28629 537.006 1.28268 537.59 1.27955C537.882 1.27799 538.077 1.27655 538.178 1.27573L538.202 1.27571L538.234 1.2755L538.247 1.2752L538.25 1.27518L538.252 1.27514L538.253 1.27513L538.254 1.27511L538.263 1.27502L538.27 1.27498L538.294 1.27508C539.829 2.68389 538.394 4.25891 538.317 4.26274L538.301 4.26308L538.297 4.26313L538.294 4.26317L538.286 4.26323L538.285 4.26324L538.283 4.26329L538.264 4.26343L538.24 4.26379C537.922 4.26748 536.168 4.28934 533.216 4.36201C496.786 5.25891 460.37 7.18075 423.961 9.30087C448.366 9.21121 472.75 9.19876 497.1 9.19876C514.471 9.19876 523.199 9.22331 524.858 9.26733C524.962 9.2701 525.06 9.27343 525.136 9.27804C525.161 9.27959 525.238 9.28413 525.322 9.29636C525.385 9.30667 525.606 9.36315 525.761 9.424C526.439 10.0157 526.38 11.6264 525.739 12.1398C525.594 12.1946 525.387 12.2467 525.327 12.2567C525.293 12.2614 525.24 12.2676 525.215 12.27C525.167 12.2744 525.119 12.2772 525.082 12.2791C525.003 12.2832 524.901 12.2868 524.785 12.2902C524.319 12.3037 523.44 12.3179 522.185 12.333C519.667 12.3632 515.588 12.3972 510.154 12.4343C488.414 12.5827 444.938 12.7805 392.77 12.9783C381.974 13.0192 370.805 13.0602 359.38 13.1007C259.944 18.7845 160.489 23.2266 60.9864 27.242C52.5846 28.0912 44.1889 28.9883 35.7998 29.9359C35.5461 29.9646 35.264 29.9983 34.9583 30.0364C41.4599 30.0739 47.9642 29.9914 54.4858 29.9087C59.6586 29.8431 64.8422 29.7773 70.044 29.7712C76.2585 29.7639 82.473 29.76 88.6873 29.7561C148.692 29.7183 208.687 29.6805 268.565 26.6083C282.969 25.8693 297.375 25.1807 311.78 24.5051C317.126 24.138 322.455 23.7877 327.759 23.4391C328.622 23.3823 329.485 23.3256 330.347 23.2689C331.8 23.1733 345.126 22.6377 353.795 22.3283C355.966 22.2508 357.853 22.1873 359.196 22.1481C359.866 22.1286 360.407 22.115 360.781 22.1089C360.965 22.1058 361.122 22.1044 361.238 22.1055C361.29 22.106 361.361 22.1072 361.43 22.1116L361.432 22.1117C361.456 22.1132 361.542 22.1187 361.644 22.1373C361.668 22.1417 361.847 22.1715 362.05 22.2681C362.178 22.3365 362.495 22.5852 362.658 22.7839C362.842 23.1515 362.873 23.9566 362.72 24.3349C362.575 24.542 362.284 24.8107 362.163 24.8883C362.088 24.9295 361.959 24.9883 361.905 25.0086C361.806 25.0445 361.724 25.0629 361.694 25.0696C361.665 25.0757 361.639 25.0808 361.615 25.0849C361.579 25.0912 361.55 25.0952 361.534 25.0974C361.502 25.1017 361.468 25.1056 361.435 25.109C361.403 25.1124 361.371 25.1155 361.341 25.1181C361.214 25.1295 361.037 25.1424 360.814 25.1571C360.364 25.1867 359.683 25.226 358.744 25.2763C356.863 25.377 353.923 25.5229 349.667 25.7244C342.02 26.0863 334.375 26.4426 326.73 26.7988C321.814 27.0278 316.899 27.2569 311.984 27.4874C276.23 29.9435 239.937 33.136 205.419 41.5621C212.472 41.0393 219.517 40.1703 226.587 39.2982C231.168 38.733 235.76 38.1666 240.372 37.6922C241.227 37.6043 241.994 38.1981 242.085 39.0186C242.177 39.8391 241.558 40.5756 240.704 40.6635C236.233 41.1234 231.717 41.6802 227.173 42.2403C217.301 43.4573 207.301 44.6902 197.367 44.9792C195.915 45.0214 194.861 45.004 194.229 44.8838C194.066 44.8527 193.82 44.7956 193.574 44.6732C193.377 44.5752 192.78 44.2325 192.664 43.4748C192.549 42.7284 193.006 42.2393 193.151 42.0987C193.339 41.9175 193.542 41.7976 193.67 41.7286C194.158 41.4642 194.938 41.2154 195.667 41.0013C196.45 40.7717 197.376 40.5264 198.27 40.2894L198.279 40.287C214.7 35.9377 231.548 32.8428 248.555 30.517C195.294 32.6774 141.962 32.7109 88.6968 32.7444C82.4795 32.7483 76.2631 32.7522 70.0478 32.7595C64.9269 32.7655 59.7855 32.8306 54.6331 32.8958C43.7752 33.0333 32.869 33.1714 22.0049 32.7583C21.691 32.7464 21.3952 32.7246 21.1433 32.683C21.02 32.6626 20.8576 32.6297 20.6892 32.5704C20.5718 32.529 20.1996 32.3929 19.9085 32.0354C19.7374 31.8252 19.5893 31.53 19.5685 31.1682C19.5482 30.8147 19.6566 30.5246 19.7723 30.3258C19.9736 29.9796 20.2616 29.7941 20.3612 29.732C20.6072 29.5785 20.8882 29.4769 21.0805 29.4129C21.728 29.1973 22.8102 28.9558 24.0594 28.714C16.5797 29.0088 9.09962 29.3018 1.61926 29.5933C0.760538 29.6267 0.0361528 28.9855 0.00130404 28.1609C-0.0335448 27.3364 0.634339 26.6409 1.49306 26.6074C21.2507 25.8376 41.0057 25.0573 60.7583 24.2602C111.267 19.1572 161.99 15.7816 212.798 13.5492C160.323 13.6825 112.384 13.7696 79.7517 13.7696C77.4008 13.7696 75.624 13.7524 74.3737 13.7194C73.7499 13.7029 73.2437 13.6822 72.8567 13.6564C72.5293 13.6346 72.1326 13.6018 71.8364 13.5197C71.764 13.4997 71.5662 13.443 71.3575 13.3125C71.2208 13.2271 70.48 12.7189 70.6583 11.7702C70.7321 11.3775 70.9449 11.1167 71.0798 10.983C71.2173 10.8467 71.3529 10.763 71.4323 10.7185C71.5898 10.6304 71.7351 10.5824 71.8068 10.5601C72.0797 10.4755 72.4468 10.4213 72.769 10.3798C73.4913 10.2869 74.6259 10.1855 76.0906 10.0765C81.9698 9.63891 93.7064 9.04054 107.758 8.39345C127.471 7.48567 151.798 6.47949 171.038 5.68368C179.242 5.34437 186.521 5.0433 192.123 4.80441ZM126.975 21.5162C180.338 17.6072 233.885 15.3341 287.472 14.0131C233.984 16.7743 180.487 19.233 126.975 21.5162ZM366.757 9.68301C353.23 9.82129 339.701 9.99875 326.171 10.2264C254.999 10.463 178.494 10.6686 121.961 10.7472C138.414 10.0241 156.3 9.28434 171.16 8.66971C179.367 8.33025 186.652 8.02897 192.261 7.78977C271.42 4.41443 350.653 2.64502 429.884 3.04374C444.605 3.11782 459.375 3.34939 474.157 3.59199C448.591 4.82872 423.039 6.35021 397.51 7.8703C388.003 8.43637 378.499 9.00224 369 9.55314C368.252 9.5965 367.504 9.63979 366.757 9.68301ZM195.199 44.3315C195.199 44.3311 195.2 44.3307 195.201 44.3303C195.191 44.3363 195.189 44.3366 195.199 44.3315ZM21.6615 29.7362C21.6615 29.7362 21.6632 29.7365 21.6664 29.7372C21.663 29.7366 21.6614 29.7363 21.6615 29.7362Z'
              fill='#FFB800'
            />
          </svg>
        </div>
        <div className='max-w-sm font-medium transition'>
          {submitted
            ? "Hurray, you have successfully joined our waitlist. we will send you an email informing you when we are launching. Before you go, please help us refer a friend."
            : "Join the waitlist and stream millions of songs from your favourite african artists on our platform"}
        </div>
        {submitted ? (
          <div className='transition flex flex-col items-center space-y-3 w-full max-w-md px-2'>
            <div className='bg-white rounded-md text-left p-2 w-full text-main-200 overflow-x-hidden'>
              <p className='text-xs'>Here's your referal link</p>
              <span className='text-sm font-medium w-full overflow-x-hidden truncate'>
                {refLink}
              </span>
            </div>
            <button
              className='btn w-full flex items-center space-x-2 justify-center'
              onClick={() => copy(refLink)}
            >
              <Copy color='white' size={20} />
              <span>{copied.value === refLink ? "Copied" : "Copy Link"}</span>
            </button>
          </div>
        ) : (
          <div className='transition flex flex-col items-center space-y-3 w-full max-w-md px-2'>
            <motion.input
              type='email'
              placeholder='Email Address'
              name='email'
              id='email'
              className='input bg-white text-black w-full'
              onChange={(e) => setEmail(e.target.value)}
              disabled={loading}
            />
            <button
              disabled={loading}
              className='btn w-full'
              onClick={() => handleSubmit()}
            >
              {loading ? (
                <div className='flex items-center justify-center space-x-2'>
                  <Spinner size={24} className='animate-spin' />
                  <span>Getting Access</span>
                </div>
              ) : (
                "Get Early Access"
              )}
            </button>
          </div>
        )}

        <motion.img
          initial={{
            translateY: "100%",
          }}
          animate={{
            translateY: "0%",
          }}
          transition={{
            duration: 0.8,
            ease: "easeInOut",
          }}
          src={require("../assets/images/Lyrics.png")}
          alt='Now Playing'
          className='w-[100%] h-[40vh] object-cover object-top'
        />
      </motion.div>
      <div className='text-xs font-poppins my-4 mx-6 flex items-center space-x-2 justify-center'>
        {socialMediaHandles.map((handle, index) => {
          return (
            <a
              key={index}
              href={handle.link}
              target='_blank'
              title={handle.name}
              rel='noreferrer'
              className='bg-main-200/30 hover:bg-main-200/40 cursor-pointer rounded-md p-2'
            >
              {<handle.icon color='white' size={20} />}
            </a>
          );
        })}
      </div>
      <div className='text-center text-xs text-gray-500 py-4'>
        &copy; {new Date().getFullYear()} Beatfro. All Rights Reserved.
      </div>
    </div>
  );
};

export default Index;
